import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import AdvertisementMappingValidationSchema from "../Validations/BannerValidation";

function AdvertisementsMapping({
  open,
  onClose,
  advertisementsMap,
  onSuccess,
}) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [universities, setUniversities] = useState([]);
  const [selectedUniversityIds, setSelectedUniversityIds] = useState([]);
  const [screens, setScreens] = useState([]);
  console.log(advertisementsMap);

  // Fetch universities and screens once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [universitiesRes, screensRes] = await Promise.all([
          api.get("/getAllUniversities"),
          api.get("/getScreens"),
        ]);
        setUniversities(universitiesRes.data.data);
        setScreens(screensRes.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);

  // Fetch courses, filtered by the selected universities via a param filter
  useEffect(() => {
    const params = {};
    if (selectedUniversityIds.length > 0) {
      params.universityIds = selectedUniversityIds;
    }

    api
      .get("/getCourses", {
        params: { ...params, active: true },
        // Send repeated "universityIds=1&universityIds=2" (Spring @RequestParam
        // List<Long> convention) instead of axios' default "universityIds[]=1"
        paramsSerializer: (p) => {
          const searchParams = new URLSearchParams();
          Object.keys(p).forEach((key) => {
            if (Array.isArray(p[key])) {
              p[key].forEach((value) => searchParams.append(key, value));
            } else {
              searchParams.append(key, p[key]);
            }
          });
          return searchParams.toString();
        },
      })
      .then((res) => setCourses(res.data.data))
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching courses";
        setError(message);
        console.error("Courses fetch error:", err);
      });
  }, [selectedUniversityIds]);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      adId: advertisementsMap?.adId || "",
      courseIds: advertisementsMap?.courses
        ? advertisementsMap.courses.map((c) => c.id)
        : [],
   
      screenIds: advertisementsMap?.screenName
        ? advertisementsMap.screenName.map((s) => s.id)
        : [],
      active:
        advertisementsMap?.active !== undefined
          ? String(advertisementsMap.active)
          : "true",
    },

    validationSchema:
      AdvertisementMappingValidationSchema.AdvertisementMappingValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log(advertisementsMap?.id);
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (advertisementsMap?.id) {
          response = await api.post(`/api/v1/courseAdMapping`, values);
          console.log(values);
        }
        // Show success toast
        toast.success(`Advertisement Course Mapped successfully!`, {
          position: "top-right",
          autoClose: 2000,
        });
        onSuccess(response.data.data);
        resetForm();
        onClose();
        // setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {advertisementsMap && Object.keys(advertisementsMap).length > 0
              ? "Advertisement Course Mapping"
              : "Advertisement Course Mapping"}
          </Typography>

          <Box sx={FORM_STYLES.container}>
            <TextField
              label="Advertisement ID"
              name="adId"
              disabled={!!advertisementsMap?.adId}
              value={formik.values.adId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.adId && Boolean(formik.errors.adId)}
              helperText={formik.touched.adId && formik.errors.adId}
              InputProps={{ readOnly: !!advertisementsMap?.adId }}
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl fullWidth>
              <InputLabel>University</InputLabel>
              <Select
                multiple
                label="University"
                value={selectedUniversityIds}
                onChange={(e) => {
                  setSelectedUniversityIds(e.target.value);
                  formik.setFieldValue("courseIds", []);
                }}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => {
                      const university = universities.find((u) => u.id === id);
                      return (
                        <Chip
                          key={id}
                          label={university?.name || id}
                          size="small"
                          onDelete={() => {
                            setSelectedUniversityIds((prev) =>
                              prev.filter((uId) => uId !== id),
                            );
                            formik.setFieldValue("courseIds", []);
                          }}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                {universities.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              sx={{ mt: 2 }}
              error={
                (formik.touched.courseIds || formik.submitCount > 0) &&
                Boolean(formik.errors.courseIds)
              }
            >
              <InputLabel>Courses</InputLabel>
              <Select
                multiple
                value={formik.values.courseIds}
                onChange={(e) =>
                  formik.setFieldValue("courseIds", e.target.value)
                }
                onBlur={() => formik.setFieldTouched("courseIds", true)}
                input={<OutlinedInput label="Courses" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((id) => {
                      const course = courses.find((c) => c.id === id);
                      return (
                        <Chip
                          key={id}
                          label={course?.courseName || id}
                          size="small"
                        />
                      );
                    })}
                  </Box>
                )}
                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
              >
                {courses.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.courseName}
                  </MenuItem>
                ))}
              </Select>
              {(formik.touched.courseIds || formik.submitCount > 0) &&
                formik.errors.courseIds && (
                  <FormHelperText>{formik.errors.courseIds}</FormHelperText>
                )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.screenIds && Boolean(formik.errors.screenIds)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="screenIds-label">Screen IDs</InputLabel>

              <Select
                labelId="screenIds-label"
                id="screenIds"
                multiple
                name="screenIds"
                value={formik.values.screenIds}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                input={<OutlinedInput label="Screen ID" />}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => {
                      const selectedScreen = screens.find(
                        (s) => s.id === value,
                      );

                      return (
                        <Chip
                          key={value}
                          label={`${selectedScreen?.id} - ${selectedScreen?.name}`}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                          onDelete={() => {
                            const updatedValues = formik.values.screenIds.filter(
                              (item) => item !== value,
                            );

                            formik.setFieldValue("screenIds", updatedValues);
                          }}
                        />
                      );
                    })}
                  </Box>
                )}
              >
                {screens.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.id} - {s.name}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.screenIds && formik.errors.screenIds && (
                <FormHelperText>{formik.errors.screenIds}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AdvertisementsMapping;
